import React from 'react';

export default class BrandworksAnimation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hover: false };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseOver() {
    console.log('handle mouse over');
    this.setState({ hover: true }, () => {
      console.log(this.state.hover);
    });
  }

  handleMouseLeave() {
    console.log('handle mouse leave');
    this.setState({ hover: false }, () => {
      console.log(this.state.hover);
    });
  }

  render() {
    return (
      <div
        onFocus={this.handleMouseOver}
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        className={
          this.state.hover ? 'animation--expanded' : 'animation--collapsed'
        }
      />
    );
  }
}
